import React, {useState, useCallback} from 'react'
import PropTypes from 'prop-types'
import {useTranslation} from 'react-i18next'
import {Flex, Button} from '@chakra-ui/react'
import {useRails} from '~/react/contexts/rails'
import {Alert} from '~/react/components'
import {requestVerification} from '~/api'

// Extracted Button Component
const VerifyNowButton = ({isLoading, onClick, t}) => (
  <Button
    isLoading={isLoading}
    as="a"
    onClick={onClick}
    variant="secondary"
    role="button"
    name={t('pointsOnPayments:bill.tabs.payBills.callToAction')}
    sx={{backgroundColor: 'transparent'}}
  >
    {t('pointsOnPayments:kyc.generic.instructions.none.callToAction')}
  </Button>
)

// Extracted Message Component
const AlertMessage = ({isVerificationPending, isLoading, onClick, t}) => (
  <Flex direction="column" gap="xs" align="flex-start">
    {t(
      `pointsOnPayments:kyc.generic.statusDescription.${
        isVerificationPending ? 'pending' : 'none'
      }`,
    )}
    {!isVerificationPending && (
      <VerifyNowButton isLoading={isLoading} onClick={onClick} t={t} />
    )}
  </Flex>
)

export const NoKyc = () => {
  const {t} = useTranslation('pointsOnPayments')

  const {
    organisation: {
      currentSupplier: {id: supplierId, verificationStatus},
    },
    authenticityToken,
  } = useRails()

  const [isVerificationPending, setIsVerificationPending] = useState(
    verificationStatus === 'pending',
  )

  const [isLoading, setIsLoading] = useState(false)

  const handleVerifyNowClick = useCallback(() => {
    if (isLoading) return

    setIsLoading(true)

    requestVerification({authenticityToken, supplierId})
      .then(() => {
        setIsVerificationPending(true)
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Failed to initiate KYC process:', error)
      })
      .finally(() => setIsLoading(false))
  }, [isLoading, authenticityToken, supplierId])

  return (
    <Alert
      status="warning"
      title={t('pointsOnPayments:kyc.generic.instructions.none.title')}
      message={
        <AlertMessage
          isVerificationPending={isVerificationPending}
          isLoading={isLoading}
          onClick={handleVerifyNowClick}
          t={t}
        />
      }
    />
  )
}

AlertMessage.propTypes = {
  isVerificationPending: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
}

VerifyNowButton.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
}

export default NoKyc
